module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f8916607225adec64cb5c459495aa4c8.png";